<template>
  <div class="action-element-wrapper">
    <div class="element-header">
      <span class="element-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
        <span>Action (Background)</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="action-content">
      <div class="action-info">
        <div class="info-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <p class="action-description">
          Déclenche une action planifiée en arrière-plan sans bloquer la conversation actuelle.
        </p>
      </div>
      
      <div class="action-control">
        <label class="control-label">Action à déclencher :</label>
        <ActionSelector 
          :idBot="$route.params.idchatbot"
          v-model="element.action_id"
          placeholder="Sélectionnez une action..."
          @change="onActionSelected"
        />
        <small class="helper-text">Rendez-vous dans le gestionnaire d'Actions pour créer de nouvelles actions.</small>
      </div>
    </div>
  </div>
</template>

<script>
import ActionSelector from '@/components/common/ActionSelector.vue';

export default {
  name: 'ActionElement',
  components: {
    ActionSelector
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateActionId(value) {
      const updatedElement = { 
        ...this.element, 
        action_id: value 
      };
      this.$emit('update', updatedElement);
    },
    onActionSelected(action) {
      if (action) {
        this.updateActionId(action.action_id || action._id);
      } else {
        this.updateActionId('');
      }
    }
  }
}
</script>

<style scoped>
.action-element-wrapper {
  background: #ffffff;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 10px 25px rgba(20, 48, 40, 0.08);
  border: 1px solid rgba(20, 48, 40, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 20px;
}

.action-element-wrapper:hover {
  box-shadow: 0 15px 35px rgba(20, 48, 40, 0.12);
  border-color: rgba(218, 255, 209, 0.5);
  transform: translateY(-2px);
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: #143028; /* Peelo dark green */
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.element-type-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #DAFFD1; /* Peelo light green */
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.element-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.25s ease;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: scale(1.05);
}

.action-btn.delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
  border-color: #ef4444;
}

.action-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.action-info {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #143028;
  color: #DAFFD1;
  border-radius: 50%;
  flex-shrink: 0;
}

.action-description {
  margin: 0;
  color: #475569;
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
}

.action-control {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.control-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.modern-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #334155;
  background: #ffffff;
  outline: none;
  transition: all 0.2s;
  font-family: inherit;
}

.modern-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.helper-text {
  font-size: 0.8rem;
  color: #64748b;
  margin-top: 4px;
}
</style>
